(function () {
  'use strict';
  var root = document.getElementById('ax');
  if (!root) return;

  /* Windows ships with "Animation effects" off on many laptops, which reports
     prefers-reduced-motion. The brand wants the motion everywhere, so it is
     only switched off with ?motion=off in the URL. */
  var RM = /[?&]motion=off/.test(location.search);
  var FINE = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };

  /* Animations are opt-in: the markup is fully visible without JS, and this
     class is what switches the reveal transitions on. If this script never
     runs, the page still reads correctly. */
  if (!RM) root.classList.add('anim');

  /* ---------- reveal on scroll ---------- */
  if (!RM && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        if (e.target.hasAttribute('data-count')) countUp(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    root.querySelectorAll('[data-mask],[data-rise],[data-wipe],[data-count]').forEach(function (n) { io.observe(n); });
  } else {
    root.querySelectorAll('[data-mask],[data-rise],[data-wipe],[data-count]').forEach(function (n) { n.classList.add('in'); });
  }

  function countUp(b) {
    var to = parseInt(b.getAttribute('data-count'), 10);
    if (isNaN(to) || RM) return;
    var t0 = performance.now(), dur = 1100;
    (function tick(t) {
      var p = clamp((t - t0) / dur, 0, 1), e = 1 - Math.pow(1 - p, 3);
      b.textContent = Math.round(to * e);
      if (p < 1) requestAnimationFrame(tick);
    })(t0);
  }

  /* ---------- colour match: every panel takes its colour from its own photo ---------- */
  function pickColour(src, cb) {
    /* two reads of the photo: the garment in the centre, and the whole frame */
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var w = 48, h = 60, c = document.createElement('canvas');
        c.width = w; c.height = h;
        var x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(im, 0, 0, w, h);
        var d = x.getImageData(0, 0, w, h).data, P = {}, F = {}, bp = null, bf = null;
        for (var i = 0; i < d.length; i += 4) {
          var p = i / 4, px = (p % w) / w - 0.5, py = Math.floor(p / w) / h - 0.48;
          var cen = Math.exp(-(px * px + py * py) / 0.06);
          var r = d[i], g = d[i + 1], b = d[i + 2];
          var mx = Math.max(r, g, b), mn = Math.min(r, g, b);
          var s = mx ? (mx - mn) / mx : 0, l = (mx + mn) / 510;
          if (l > 0.97) continue;
          var k = ((r >> 5) << 6) | ((g >> 5) << 3) | (b >> 5);
          var o = P[k] || (P[k] = { w: 0, r: 0, g: 0, b: 0, n: 0 });
          o.w += (0.12 + s * s * 4) * cen; o.r += r; o.g += g; o.b += b; o.n++;
          if (!bp || o.w > bp.w) bp = o;
          if (l < 0.07) continue;
          var f = F[k] || (F[k] = { w: 0, r: 0, g: 0, b: 0, n: 0 });
          f.w += 0.25 + s * 2; f.r += r; f.g += g; f.b += b; f.n++;
          if (!bf || f.w > bf.w) bf = f;
        }
        var avg = function (o) { return o ? [o.r / o.n, o.g / o.n, o.b / o.n] : null; };
        cb(avg(bp), avg(bf));
      } catch (e) {}
    };
    im.src = src;
  }
  function toHsl(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), h = 0, s = 0, l = (mx + mn) / 2;
    if (mx !== mn) {
      var dd = mx - mn;
      s = l > 0.5 ? dd / (2 - mx - mn) : dd / (mx + mn);
      h = mx === r ? (g - b) / dd + (g < b ? 6 : 0) : mx === g ? (b - r) / dd + 2 : (r - g) / dd + 4;
      h *= 60;
    }
    return [h, s, l];
  }
  function small(img) {
    var u = img.currentSrc || img.src;
    try { var U = new URL(u, location.href); U.searchParams.set('width', '120'); return U.toString(); } catch (e) { return u; }
  }
  var hsl = function (h, s, l) { return 'hsl(' + Math.round(h) + ',' + Math.round(s * 100) + '%,' + Math.round(l * 100) + '%)'; };
  root.querySelectorAll('.panel').forEach(function (sec) {
    var img = sec.querySelector('.shoe');
    if (!img) return;
    var src = small(img);
    pickColour(src, function (prod, frame) {
      if (!prod) return;
      var tp = toHsl(prod[0], prod[1], prod[2]), tf = frame ? toHsl(frame[0], frame[1], frame[2]) : null;
      var H, S, L, light;
      if (tp[1] >= 0.25 && tp[2] > 0.12) { H = tp[0]; S = tp[1]; L = tp[2]; }          /* coloured garment: use it */
      else if (tf && tf[1] >= 0.25) { H = tf[0]; S = tf[1]; L = tf[2]; }               /* neutral garment, coloured scene */
      else { H = tp[0]; S = Math.min(tp[1], 0.12); L = tp[2]; }                          /* neutral all round: black or white */
      S = Math.min(S, 0.72);
      light = L > 0.6;
      L = light ? Math.max(L, 0.82) : Math.min(Math.max(L, 0.14), 0.4);
      sec.style.setProperty('--c', hsl(H, S, L));
      sec.classList.toggle('light', light);
      var word = sec.querySelector('.word');
      if (word) word.style.setProperty('--w', light ? 'rgba(0,0,0,.10)' : 'rgba(255,255,255,.14)');
    });
  });
  (function () {
    var hi = root.querySelector('.hero-shoe img'), aura = root.querySelector('.hero-shoe .aura');
    if (!hi || !aura) return;
    pickColour(small(hi), function (prod, frame) {
      var src3 = (frame && toHsl(frame[0], frame[1], frame[2])[1] >= 0.25) ? frame : prod;
      if (!src3) return;
      var t = toHsl(src3[0], src3[1], src3[2]);
      aura.style.background = 'radial-gradient(circle, ' + hsl(t[0], Math.min(t[1], 0.8), 0.55).replace('hsl', 'hsla').replace(')', ',.38)') + ', rgba(0,0,0,0) 68%)';
    });
  })();

  /* ---------- anatomy hotspots ---------- */
  var hots = root.querySelectorAll('.hot');
  var items = root.querySelectorAll('.anat-item');
  function setAnat(i) {
    hots.forEach(function (h, j) { h.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
    items.forEach(function (it, j) { it.classList.toggle('on', j === i); });
  }
  hots.forEach(function (h, i) { h.addEventListener('click', function () { setAnat(i); }); });
  items.forEach(function (it, i) { it.addEventListener('click', function () { setAnat(i); }); });

  /* ---------- size & fit ---------- */
  var sizeBtns = Array.prototype.slice.call(root.querySelectorAll('.size'));
  var fitTitle = document.getElementById('fitTitle');
  var fitSub = document.getElementById('fitSub');
  var fitBar = document.getElementById('fitBar');
  var rows = root.querySelectorAll('.sizetable tbody tr');
  sizeBtns.forEach(function (b, i) {
    b.addEventListener('click', function () {
      sizeBtns.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
      b.setAttribute('aria-pressed', 'true');
      rows.forEach(function (r, j) { r.classList.toggle('on', j === i); });
      if (fitTitle) fitTitle.textContent = 'Size ' + b.getAttribute('data-size');
      if (fitSub) fitSub.textContent = b.getAttribute('data-read') || '';
      if (fitBar) fitBar.style.width = Math.round(((i + 1) / sizeBtns.length) * 100) + '%';
    });
  });

  /* ---------- craft: image follows the step in view ---------- */
  var steps = Array.prototype.slice.call(root.querySelectorAll('.step'));
  var craftImg = document.getElementById('craftImg');
  var craftMedia = document.getElementById('craftMedia');
  var curStep = 0;
  function setStep(i) {
    if (i === curStep || !craftImg) return;
    curStep = i;
    steps.forEach(function (e, j) { e.classList.toggle('on', j === i); });
    var src = steps[i].getAttribute('data-img');
    var c = steps[i].getAttribute('data-c');
    craftImg.style.opacity = '0';
    craftImg.style.transform = 'scale(.94) rotate(-4deg)';
    if (craftMedia && c) craftMedia.style.setProperty('--cm', c);
    setTimeout(function () {
      if (src) craftImg.src = src;
      craftImg.style.opacity = '1';
      craftImg.style.transform = 'none';
    }, 220);
  }

  /* ---------- scroll engine ---------- */
  var nav = document.getElementById('nav');
  var prog = document.getElementById('prog');
  var panels = Array.prototype.slice.call(root.querySelectorAll('.panel'));
  var looks = Array.prototype.slice.call(root.querySelectorAll('.look'));
  var ticking = false;

  /* panel motion is eased toward the scroll position every frame, so a
     stepped mouse wheel (Windows) glides like a trackpad instead of jumping */
  var pRaf = 0;
  function paintPanel(sec, p) {
    var q = p - 0.5;
    var shoe = sec.querySelector('.shoe'), word = sec.querySelector('.word');
    if (shoe) shoe.style.transform = 'translate3d(0,' + (-q * 96) + 'px,0) rotate(' + (-7 + p * 7) + 'deg) scale(' + (0.9 + p * 0.1) + ')';
    if (word) word.style.transform = 'translate3d(' + (-q * 30) + '%,' + (-q * 36) + 'px,0) scale(' + (1 + p * 0.09) + ')';
  }
  function smoothPanels() {
    var moving = false;
    panels.forEach(function (sec) {
      if (sec.__tp == null) return;
      if (sec.__cp == null) sec.__cp = sec.__tp;
      var d = sec.__tp - sec.__cp;
      if (Math.abs(d) > 0.0004) { sec.__cp += d * 0.14; moving = true; } else { sec.__cp = sec.__tp; }
      paintPanel(sec, sec.__cp);
    });
    pRaf = moving ? requestAnimationFrame(smoothPanels) : 0;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var y = window.pageYOffset, vh = window.innerHeight;
      if (nav) nav.classList.toggle('solid', y > 40);
      if (prog) {
        var h = document.documentElement.scrollHeight - vh;
        prog.style.transform = 'scaleX(' + (h > 0 ? y / h : 0) + ')';
      }
      if (RM) return;

      panels.forEach(function (sec) {
        var r = sec.getBoundingClientRect();
        if (r.bottom < -80 || r.top > vh + 80) return;
        sec.__tp = clamp(-r.top / Math.max(1, r.height - vh), 0, 1);
      });
      if (!pRaf) pRaf = requestAnimationFrame(smoothPanels);

      looks.forEach(function (n) {
        var r = n.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var im = n.querySelector('img');
        if (im) im.style.setProperty('--p', ((((r.top + r.height / 2) / vh) - 0.5) * -22) + 'px');
      });

      if (steps.length) {
        var best = 0, bd = 1e9;
        steps.forEach(function (e, i) {
          var r = e.getBoundingClientRect(), d = Math.abs(r.top + r.height / 2 - vh * 0.5);
          if (d < bd) { bd = d; best = i; }
        });
        setStep(best);
      }
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();

  /* ---------- cursor + magnetic buttons (desktop only) ---------- */
  if (FINE && !RM) {
    root.classList.add('hascursor');
    var cur = document.getElementById('cursor'), cx = 0, cy = 0, tx = 0, ty = 0;
    if (cur) {
      window.addEventListener('mousemove', function (e) { tx = e.clientX; ty = e.clientY; });
      (function loop() {
        cx += (tx - cx) * 0.18; cy += (ty - cy) * 0.18;
        cur.style.transform = 'translate(' + cx + 'px,' + cy + 'px) translate(-50%,-50%)';
        requestAnimationFrame(loop);
      })();
      root.addEventListener('mouseover', function (e) { if (e.target.closest('a,button,.product,.look,.hot')) cur.classList.add('big'); });
      root.addEventListener('mouseout', function (e) { if (e.target.closest('a,button,.product,.look,.hot')) cur.classList.remove('big'); });
    }
    root.querySelectorAll('[data-mag]').forEach(function (b) {
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.transform = 'translate(' + (e.clientX - r.left - r.width / 2) * 0.2 + 'px,' + (e.clientY - r.top - r.height / 2) * 0.3 + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }

  /* ---------- Fit Run ---------- */
  (function () {
    var cv = document.getElementById('gCanvas');
    if (!cv) return;
    var ctx = cv.getContext('2d');
    var CS = getComputedStyle(root);
    var cv_ = function (n, d) { return (CS.getPropertyValue(n) || '').trim() || d; };
    var GOLD = cv_('--gold', '#D8A93B');
    var G_BG = cv_('--g-bg', '#08080C'), G_FG = cv_('--g-fg', '#F4F0E8'), G_OB = cv_('--g-ob', '#C8342E');
    var G_RGB = cv_('--g-rgb', '244,240,232');
    if (window.innerWidth < 760) { cv.width = 760; cv.height = 500; }
    var W = cv.width, H = cv.height, GROUND = H - 92;
    var KEY = 'sizingstore_fitrun_best';
    var best = 0; try { best = parseInt(localStorage.getItem(KEY) || '0', 10) || 0; } catch (e) {}
    var bestEl = document.getElementById('gBest'); if (bestEl) bestEl.textContent = best;
    var scoreEl = document.getElementById('gScore'), over = document.getElementById('gOver');
    var titleEl = document.getElementById('gTitle'), msgEl = document.getElementById('gMsg'), btn = document.getElementById('gBtn');
    var run = false, raf = 0, t = 0, score = 0, spd = 8.4;
    var p = { x: 165, y: GROUND, vy: 0, jumps: 0 };
    var obs = [], lace = [], puff = [];

    function reset() { t = 0; score = 0; spd = 8.4; obs = []; lace = []; puff = []; p.y = GROUND; p.vy = 0; p.jumps = 0; if (scoreEl) scoreEl.textContent = '0'; }
    function jump() {
      if (!run) { start(); return; }
      if (p.jumps < 2) {
        p.vy = p.jumps === 0 ? -20.5 : -17; p.jumps++;
        for (var i = 0; i < 7; i++) puff.push({ x: p.x, y: p.y, vx: -Math.random() * 5 - 1, vy: Math.random() * 3 - 1.4, l: 26 });
      }
    }
    function start() { reset(); run = true; if (over) over.classList.add('hide'); cancelAnimationFrame(raf); loop(); }
    function stop() {
      run = false;
      if (score > best) { best = score; try { localStorage.setItem(KEY, String(best)); } catch (e) {} if (bestEl) bestEl.textContent = best; }
      if (titleEl) titleEl.textContent = 'Wiped out';
      if (msgEl) msgEl.textContent = 'Score ' + score + ' · Best ' + best;
      if (btn) btn.textContent = 'Play again';
      if (over) over.classList.remove('hide');
    }
    function sprite(x, y, sq) {
      /* a folded oversized tee */
      ctx.save(); ctx.translate(x, y - 34); ctx.rotate(sq * 0.16); ctx.scale(1.2, 1.2);
      ctx.fillStyle = G_FG;
      ctx.beginPath();
      ctx.moveTo(-14, -30); ctx.quadraticCurveTo(0, -22, 14, -30);
      ctx.lineTo(40, -20); ctx.lineTo(50, -2); ctx.lineTo(32, 6); ctx.lineTo(28, -2);
      ctx.lineTo(28, 30); ctx.lineTo(-28, 30); ctx.lineTo(-28, -2); ctx.lineTo(-32, 6);
      ctx.lineTo(-50, -2); ctx.lineTo(-40, -20); ctx.closePath(); ctx.fill();
      ctx.fillStyle = GOLD;
      ctx.fillRect(-12, -6, 24, 16);
      ctx.fillStyle = '#0A0A0E'; ctx.fillRect(-28, 30, 56, 5);
      ctx.restore();
    }
    function loop() {
      raf = requestAnimationFrame(loop);
      t++; if (t % 6 === 0) { score++; if (scoreEl) scoreEl.textContent = score; }
      spd += 0.0016;
      ctx.fillStyle = G_BG; ctx.fillRect(0, 0, W, H);
      ctx.fillStyle = 'rgba(' + G_RGB + ',.05)';
      for (var b = 0; b < 5; b++) ctx.fillRect((W - ((t * (0.7 + b * 0.3)) % (W + 320))) - 160, 110 + b * 52, 220, 3);
      ctx.strokeStyle = 'rgba(' + G_RGB + ',.2)'; ctx.lineWidth = 2;
      ctx.beginPath(); ctx.moveTo(0, GROUND + 9); ctx.lineTo(W, GROUND + 9); ctx.stroke();
      ctx.strokeStyle = 'rgba(' + G_RGB + ',.12)';
      for (var d = 0; d < 20; d++) {
        var dx = (W - ((t * spd * 0.5 + d * 130) % (W + 200)));
        ctx.beginPath(); ctx.moveTo(dx, GROUND + 34); ctx.lineTo(dx + 46, GROUND + 34); ctx.stroke();
      }
      if (t % Math.max(46, Math.round(96 - spd * 3)) === 0) {
        var tall = Math.random() < 0.35;
        obs.push({ x: W + 60, w: tall ? 40 : 66, h: tall ? 104 : 58 });
      }
      if (t % 130 === 0) lace.push({ x: W + 60, y: GROUND - 130 - Math.random() * 80, r: 17 });
      p.vy += 1.06; p.y += p.vy;
      if (p.y > GROUND) { p.y = GROUND; p.vy = 0; p.jumps = 0; }
      ctx.fillStyle = 'rgba(' + G_RGB + ',.28)';
      for (var i = puff.length - 1; i >= 0; i--) {
        var q = puff[i]; q.x += q.vx; q.y += q.vy; q.l--;
        if (q.l <= 0) { puff.splice(i, 1); continue; }
        ctx.globalAlpha = q.l / 30; ctx.beginPath(); ctx.arc(q.x, q.y, q.l * 0.18, 0, 7); ctx.fill();
      }
      ctx.globalAlpha = 1;
      for (var j = obs.length - 1; j >= 0; j--) {
        var o = obs[j]; o.x -= spd;
        ctx.fillStyle = G_OB; ctx.fillRect(o.x, GROUND + 9 - o.h, o.w, o.h);
        ctx.fillStyle = 'rgba(0,0,0,.32)'; ctx.fillRect(o.x, GROUND + 9 - o.h, o.w, 10);
        if (o.x < -80) { obs.splice(j, 1); continue; }
        if (o.x < p.x + 62 && o.x + o.w > p.x - 62 && p.y > GROUND + 9 - o.h - 6) { stop(); cancelAnimationFrame(raf); return; }
      }
      for (var k = lace.length - 1; k >= 0; k--) {
        var l = lace[k]; l.x -= spd;
        ctx.strokeStyle = GOLD; ctx.lineWidth = 4;
        var hy = l.y + Math.sin(t * 0.1) * 3;
        ctx.beginPath(); ctx.arc(l.x, hy - 16, 6, Math.PI, Math.PI * 2.4); ctx.stroke();
        ctx.beginPath(); ctx.moveTo(l.x, hy - 10); ctx.lineTo(l.x - 22, hy + 8); ctx.lineTo(l.x + 22, hy + 8); ctx.closePath(); ctx.stroke();
        if (l.x < -40) { lace.splice(k, 1); continue; }
        if (Math.abs(l.x - p.x) < 58 && Math.abs(l.y - (p.y - 26)) < 52) {
          lace.splice(k, 1); score += 15; if (scoreEl) scoreEl.textContent = score;
          for (var m = 0; m < 8; m++) puff.push({ x: l.x, y: l.y, vx: Math.random() * 6 - 3, vy: Math.random() * 6 - 3, l: 24 });
        }
      }
      sprite(p.x, p.y, clamp(p.vy / 22, -1, 1));
    }
    if (btn) btn.addEventListener('click', start);
    window.addEventListener('keydown', function (e) {
      if (e.code !== 'Space' && e.code !== 'ArrowUp') return;
      var r = cv.getBoundingClientRect();
      if (r.top > window.innerHeight || r.bottom < 0) return;
      e.preventDefault(); jump();
    });
    cv.addEventListener('pointerdown', function (e) { e.preventDefault(); jump(); });
    if (!FINE) { var hint = document.getElementById('gHint'); if (hint) hint.textContent = 'TAP'; }
    ctx.fillStyle = G_BG; ctx.fillRect(0, 0, W, H);
    ctx.strokeStyle = 'rgba(' + G_RGB + ',.2)'; ctx.lineWidth = 2;
    ctx.beginPath(); ctx.moveTo(0, GROUND + 9); ctx.lineTo(W, GROUND + 9); ctx.stroke();
    sprite(p.x, p.y, 0);
  })();
})();

/* ---- footer: live IST clock, open light, wordmark glow, back to top ---- */
(function () {
  if (window.__slFootInit) { return; }
  window.__slFootInit = 1;
  function boot() {
    var clock  = document.getElementById('axfootClock');
    var status = document.getElementById('axfootStatus');
    if (!clock && !status) { return; }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var now = new Date();
      var ist = new Date(now.getTime() + (now.getTimezoneOffset() * 60000) + (5.5 * 3600000));
      if (clock) { clock.textContent = pad(ist.getHours()) + ':' + pad(ist.getMinutes()) + ':' + pad(ist.getSeconds()) + ' IST'; }
      if (status) {
        var day = ist.getDay();
        var from = parseInt(status.getAttribute('data-from') || '11', 10), to = parseInt(status.getAttribute('data-to') || '20', 10);
        var open = day >= 1 && day <= 6 && ist.getHours() >= from && ist.getHours() < to;
        status.setAttribute('data-open', open ? '1' : '0');
        var b = status.querySelector('b');
        if (b) { b.textContent = open ? 'Open now' : 'Closed right now'; }
      }
    }
    tick();
    setInterval(tick, 1000);

    var mark = document.getElementById('axfootMark');
    if (mark) {
      mark.addEventListener('mousemove', function (ev) {
        var r = mark.getBoundingClientRect();
        mark.style.setProperty('--mx', ((ev.clientX - r.left) / r.width * 100) + '%');
        mark.style.setProperty('--my', ((ev.clientY - r.top) / r.height * 100) + '%');
        mark.classList.add('lit');
      });
      mark.addEventListener('mouseleave', function () { mark.classList.remove('lit'); });
    }

    var up = document.getElementById('axfootTop');
    if (up) { up.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); }); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
